import { render, staticRenderFns } from "./Renderer.vue?vue&type=template&id=5388a508&"
import script from "./Renderer.vue?vue&type=script&lang=ts&"
export * from "./Renderer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports